import {
  Clock,
  Car,
  Utensils,
  CalendarDays,
  Users,
  Heart,
  Sparkles,
  Palette,
  Activity,
  Wrench,
  Shield,
  Tag,
  Star,
  Luggage,
  Leaf,
  PawPrint,
  Gift,
  LucideIcon,
} from 'lucide-react';
import {OFFER_CATEGORIES} from '@chekin/core';

type CategoryValue = (typeof OFFER_CATEGORIES)[keyof typeof OFFER_CATEGORIES];

export const CATEGORY_ICON_MAP: Record<CategoryValue, LucideIcon> = {
  [OFFER_CATEGORIES.checkInCheckOut]: Clock,
  [OFFER_CATEGORIES.checkIn]: Clock,
  [OFFER_CATEGORIES.checkOut]: Clock,
  [OFFER_CATEGORIES.transportation]: Car,
  [OFFER_CATEGORIES.fAndB]: Utensils,
  [OFFER_CATEGORIES.seasonal]: CalendarDays,
  [OFFER_CATEGORIES.family]: Users,
  [OFFER_CATEGORIES.romantic]: Heart,
  [OFFER_CATEGORIES.healthAndSpa]: Sparkles,
  [OFFER_CATEGORIES.artAndCulture]: Palette,
  [OFFER_CATEGORIES.activities]: Activity,
  [OFFER_CATEGORIES.services]: Wrench,
  [OFFER_CATEGORIES.propertyProtection]: Shield,
  [OFFER_CATEGORIES.others]: Tag,
  [OFFER_CATEGORIES.essentials]: Star,
  [OFFER_CATEGORIES.luggageServices]: Luggage,
  [OFFER_CATEGORIES.nature]: Leaf,
  [OFFER_CATEGORIES.petFriendly]: PawPrint,
  [OFFER_CATEGORIES.petFee]: PawPrint,
  [OFFER_CATEGORIES.freeOffers]: Gift,
};

export const getCategoryIcon = (category: CategoryValue): LucideIcon => {
  return CATEGORY_ICON_MAP[category] || Tag;
};
